var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTrreact = function SvgTrreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M23.55 21H.45Q0 21 0 20.55V3.45Q0 3 .45 3h23.1q.45 0 .45.45v17.1q0 .45-.45.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m14.1 10.5.75.9 1.05-.3s.15 0 .15.15l-.6.9.75.9v.15l-1.05-.3-.75.9h-.15v-1.2l-1.05-.3v-.15l1.05-.45zc-.15 0 0-.15 0 0M10.2 15.6c-1.95 0-3.6-1.65-3.6-3.6s1.65-3.6 3.6-3.6c.75 0 1.5.3 1.95.6.15 0 .15 0 .15-.15-.9-.9-2.1-1.35-3.45-1.35-2.25.15-4.2 1.95-4.35 4.2-.15 2.55 1.95 4.8 4.5 4.8 1.35 0 2.4-.6 3.3-1.35 0 0 0-.15-.15-.15-.6.3-1.2.6-1.95.6"
  })));
};
export default SvgTrreact;